<template>
  <div class="step-box flex-c-c">
    <div :class="['step flex-c-s', (active - 1) > index ? 'compelete' : (active - 1) === index ? 'active' : '']" v-for="(item, index) in list" :key="index">
      <div class="index-box">{{index + 1}}<i class="el-icon-check"></i></div>
      <div class="content">{{item.content}}</div>
      <div class="right-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step",
  props: {
    active: {
      type: Number,
      default: 1
    },
    stepList: {
      type: Array,
      default: () => {
        return [
          {
            content: "哈哈"
          }
        ]
      }
    }
  },
  watch: {
    stepList: {
      handler: function(val){
        this.list = val
      },
      immediate: true
    }
  },
  data() {
    return {
      list: []
    }
  }
}
</script>

<style lang="scss" scoped>
.step-box {
  width: 100%;
  .step {
    .index-box {
      width: 32px;
      height: 32px;
      border: 2px solid #999;
      border-radius: 50%;
      text-align: center;
      line-height: 28px;
      color: #999;
      position: relative;
      font-size: 14px;
      .el-icon-check {
        position: absolute;
        top: 0;
        left: 0;
        line-height: 28px;
        width: 100%;
        height: 100%;
        display: none;
      }
    }
    .content {
      margin-left: 12px;
      color: #999;
    }
    .right-line {
      width: 120px;
      height: 1px;
      background: #999;
      margin: 0 20px;
    }
    &:last-child {
      .right-line {
        display: none;
      }
    }
    &.active {
      .index-box {
        border-color: #008CFF;
        background: #008CFF;
        color: #fff;
      }
      .content {
        color: #333;
        font-weight: bold;
      }
    }
    &.compelete {
      .index-box {
        border-color: #008CFF;
        color: #fff;
        .el-icon-check {
          display: block;
          color: #008CFF;
          font-weight: bold;
        }
      }
      .content {
        color: #333;
        font-weight: bold;
      }
      .right-line {
        width: 120px;
        height: 1px;
        background: #008CFF;
        margin: 0 20px;
      }
    }
  }
}
</style>